import React from 'react'
import styled from 'styled-components'

import Benefits from 'pages/paywall/Benefits'
import PlanSelection from 'pages/paywall/PlanSelection'
import PremiumSelection from 'pages/paywall/FeaturesBox/PremiumSelection'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'

const BASIC_TITLE = 'Basic'
const PREMIUM_TITLE = 'Premium'

type props = {
  isBasicList: boolean | true
  onChangeSelection?: (event) => void
  selectedInput?: PlanSelection
}

const FeaturesBox = ({
  isBasicList = true,
  onChangeSelection = () => { },
  selectedInput = PlanSelection.YEARLY
}: props) => {
  const benefitList = isBasicList ? Benefits.BASIC : Benefits.PREMIUM

  return (
    <S.Container>
      <S.TitleSection>
        <S.Title>{isBasicList ? BASIC_TITLE : PREMIUM_TITLE}</S.Title>
      </S.TitleSection>

      <S.Content>
        <S.AroundList>
          {!isBasicList && <i>All the features from BASIC plus</i>}
        </S.AroundList>

        <ul>
          {benefitList.map((benefit) => (
            <S.Benefit key={benefit}>{benefit}</S.Benefit>
          ))}
        </ul>

        {!isBasicList && (
          <S.AroundList>
            <i>and so much more...</i>
          </S.AroundList>
        )}
      </S.Content>

      {isBasicList && <S.FreeBox>free</S.FreeBox>}

      {!isBasicList && (
        <PremiumSelection
          {...{
            selectedInput,
            onChangeSelection
          }}
        />
      )}
    </S.Container>
  )
}

export default FeaturesBox

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 280px;
    border: 1px solid ${Brand.accentColor()};
    border-radius: 15px;
    background-color: white;
  `,
  TitleSection: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F3F7F8;
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
  `,
  Title: styled.div`
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
  `,
  Benefit: styled.li`
    margin: 10px 0 0 0;
    padding-right: 5px;
    padding-left: 5px;
  `,
  FreeBox: styled.div`
    background-color: #F4F4F4;
    color: #9E9D9D;
    font-size: 18px;
    padding: 10px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    text-transform: uppercase;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
    color: ${color('secondaryText')};
  `,
  AroundList: styled.div`
    height: 25px;
    width: 100%;
    padding-left: 15px;
    display: flex;
  `
}
